module.exports = __webpack_public_path__ + "img/bg-data@2x.0e25ae8b.png";